import { useEffect } from 'react';
import { addGlobalShellEventListener } from '../utilities/globalShellEvents';
/**
 * Subscribe to a shell custom window event inside a React component.
 * The listener is automatically removed on unmount or when `eventName` /
 * `handler` change — wrap `handler` in `useCallback` if its identity needs
 * to be stable.
 *
 * @example
 * useGlobalShellEvents(GLOBAL_SHELL_EVENTS.ONBOARDING_STEPS_UPDATED, () => {
 *   refetch();
 * });
 */
export function useGlobalShellEvents(eventName, handler) {
    useEffect(function () {
        return addGlobalShellEventListener(eventName, handler);
    }, [eventName, handler]);
}
